import { VisitsValidationsModel } from '@w3lcome/types';
import RequestCreator from './BaseRequest';

interface VisitsValidationsRequestType extends VisitsValidationsModel {
  pictureBase64: string;
}

class VisitsValidations extends RequestCreator<VisitsValidationsRequestType> {}

const api = new VisitsValidations('/visits-validations');
export default api;
